<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-chart</h2>
            <p class="demo-description">Chart.js wrapper with reactive inputs for type and data.</p>

            <div class="demo-controls">
                <ion-button size="small" [color]="type === 'bar' ? 'primary' : 'medium'" (click)="setType('bar')">
                    Bar
                </ion-button>
                <ion-button size="small" [color]="type === 'line' ? 'primary' : 'medium'" (click)="setType('line')">
                    Line
                </ion-button>
                <ion-button size="small" [color]="type === 'pie' ? 'primary' : 'medium'" (click)="setType('pie')">
                    Pie
                </ion-button>
                <ion-button size="small" [color]="type === 'doughnut' ? 'primary' : 'medium'" (click)="setType('doughnut')">
                    Doughnut
                </ion-button>
                <ion-button size="small" color="tertiary" (click)="randomizeData()">
                    Randomize data
                </ion-button>
                <ion-button size="small" color="dark" (click)="showPaymentDoughnut()">
                    Payment example
                </ion-button>
                <ion-button size="small" [color]="legendPosition === 'bottom' ? 'secondary' : 'medium'" (click)="setLegendPosition('bottom')">
                    Legend Bottom
                </ion-button>
                <ion-button size="small" [color]="legendPosition === 'top' ? 'secondary' : 'medium'" (click)="setLegendPosition('top')">
                    Legend Top
                </ion-button>
                <ion-button size="small" [color]="legendPosition === 'right' ? 'secondary' : 'medium'" (click)="setLegendPosition('right')">
                    Legend Right
                </ion-button>
                <ion-button size="small" [color]="legendPosition === 'left' ? 'secondary' : 'medium'" (click)="setLegendPosition('left')">
                    Legend Left
                </ion-button>
                <ion-button size="small" color="success" (click)="exportPng()">
                    Export PNG
                </ion-button>
                <ion-button size="small" color="warning" (click)="exportJpg()">
                    Export JPG
                </ion-button>
            </div>

            <div class="demo-section">
                <upp-chart
                    [type]="type"
                    [data]="data"
                    [options]="options"
                    [legend]="true"
                    [legendPosition]="legendPosition"
                    [legendMaxLines]="legendMaxLines"
                    [legendOtherLabel]="legendOtherLabel"
                    [legendShowValue]="legendShowValue"
                    [legendValueDecimals]="legendValueDecimals"
                    [legendValueSuffix]="legendValueSuffix"
                    [height]="height">
                </upp-chart>
            </div>
        </div>
    </upp-scrollable>
</div>
